export default {
  Welcome: "Hello",
  SystemAutoInvoice:
    "Automatic system to look up and download e-invoices is ready to work with you <br> to get the job done",
  StartNow: "Get started now",
  WhoAreYou: "Who are you",
  SelectedSubType:
    "Select your activity type for guiding the best suitable choice",
  Enterprise: "Businesses",
  ServiceAccountCompany: "Service accounting company",
  ServiceAccountIndividual: "Individuals working as service accountants",
  Next: "Continue",
  Information: "Your information",
  DescriptionAuto:
    "When the invoice arrives at this email, theproram will automatically extract the invoice, check and enter the data into the accounting software.",
  InformationCode: "Citizenship ID/passport No.",
  FullName: "Full name",
  Phone: "Phone number",
  Email: "Email",
  TaxCode: "Tax Code",
  CompanyName: "Company name",
  Contact: "Contact name",
  StartedTitle: "Initiate an invoice receiving email",
  StartedSubTitle:
    "Please declare <span class='font-bold'>the correct information according to the business license.</span> The system will use this information to look up the legality of the invoice",
  StartedGuideTitle: "Fully automated invoice processing",
  StartedGuideSubTitle:
    "Automatically look up, analyze and check invoice information. Connect directly to accounting software in just 3 steps.",
  TitlePermission: "You're not authorized",
  SubTitlePermission:
    "Please contact your administrator for decentralized access to MISA meInvoice - Processing invoice ",
  ActiveToUse: "Activate use",
  TitleMeInvoice: "MISA meInvoice - Processing invoices",
  LicenseCode: "License code",
  FillActiveCode: "Enter the activation code for purchase at the MISA store",
  TotalInvoiceHandle: "Maximum number of invoices processed:",
  UnitUse: "Division users",
  UnitActiveUse: "Trigger unit used",
  User: "User",
  ActiveSuccess: "Activation successful",
  InvoiceCapacitySupplier: {
    FirstText: "Resources issued for tax code",
    SecondText: "In bulk",
    ThirdText: "invoice.",
  },
  LoginNow: "Login now",
  CheckKeyStatus: {
    KeyNotOfInbot: "The activation code does not belong to current product",
    KeyInvalid: "Invalid activation code",
    KeyActived: "Code has been activated",
  },
  TaxCodeWasActived:
    "The tax code has been activated. Please log in the program into resource management to reactivate!",
  TaxCodeHaveInbot:
    "This tax code already has a MISA Meinvoice account and has activated an Inbot account. Please log in to Meinvoice to use the service!",
  ErrorMessageRegister: {
    InValidParameter: "Invalid parameter",
    NotFound: "Not found MISA ID account",
    EmailOrPhoneNumberExists:
      "User with this email, phone number of MISA ID already exists",
    TaxCodeNotFound: "The tax code does not exist",
    Error: "An error occurred in registering an account.",
  },
  ChangeAccount: "Change account",
  Active: "Active",
  ActiveNow: "Activate now",
  TaxCodeIsWorking:
    "The tax code is working differently than the tax code purchased on the MISA store. Please check back.",
  Promotion: {
    TakeSale: "Promotion",
    FirstName: "First name",
    LastName: "Name",
  },
  TakeCode: "Get code",
  CreateEmailToTakeAndSend: "Creat invoice receving email",
  SystemAutoDownloadAndCheck:
    "The system automatically loads and checks the digital contract",
  Synch: "Sync to accounting software",
  ViewGuide: "View help",
  ChatWithEmployee: "Chat with online support staff here",
  GuideLiveChat:
    "Move the chat icon position by clicking, holding and moving the mouse",
  New: "New",
  ChatEmployeeForSupport: "Chat with consulting staff when you need support",
  ViewRemind: "View a reminder notifications",
  Click: "Click",
  HideSymbol: "to hide icons",
  ClickAndMouse: "Click and hold the mouse to move the position",
  RolePermissionMISAMeInvoice : 'You are not authorized to work on MISA meInvoice - Invoice processing. Please contact Admin for permission.',
  HelpDesc: "You can name the beginning of the email yourself, for example: hoadoncongty, the default automatic suffix is @meinvoice.vn"
};
